// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep .no-header {
   background-color: #ffffff;
}

.toolbar {
   align-items: center;
}

.menu > li {
   float: left;
}

.menu > li + li {
   margin-left: 1em;
}

.menu > li > a {
   border: 1px solid #bdc3c7;
   border-radius: 2px;
   cursor: pointer;
   display: block;
   padding: 5px 1em;
   position: relative;
   white-space: nowrap;
}

.menu > li > a:hover {
   background-color: #f7f7f7;
   color: #3d464d;
   text-decoration: none;
}

.toolbar .dropdown.open > a {
   background-color: #ebebeb;
   border-color: #bdc3c7;
}

.menu > li > a > i {
   font-size: 16px;
   margin-right: 10px;
}

.menu button {
   padding: 0 12px;
}

.menu button.mat-primary {
   line-height: 30px;
}

.menu button:not(.mat-primary) {
   border: 1px solid #bdc3c7;
   line-height: 28px;
}

.menu button i {
   font-size: 16px;
   margin-right: 10px;
}

.separator {
   border: none;
   border-top: 1px solid #eaeaea;
   height: 0;
   margin: 5px 0;
}

.toolbar .dropdown-menu {
   left: auto;
   right: 0;
}

.breadcrumb1 {
   line-height: 30px;
   overflow: hidden;
   white-space: nowrap;
}

.mat-form-field {
   font-size: 14px;
   width: 100%;
}

.mat-column-select {
   overflow: visible;
}

.firstSampleAnimation {
   padding: 20px;
}

.firstSampleAnimation.ng-hide-add,
.firstSampleAnimation.ng-hide-remove {
   /*-webkit-transition : 1s ease-in-out opacity;
   -moz-transition    : 1s ease-in-out opacity;
   -ms-transition     : 1s ease-in-out opacity;
   -o-transition      : 1s ease-in-out opacity;
   transition         : 1s ease-in-out opacity;*/
   opacity: 1;
}

.firstSampleAnimation.ng-hide {
   z-index: 1;
   opacity: 0;
}

.search-box {
   padding-left: 1em;
   position: relative;
}

.rate-limit-reached {
   color: #980000;
   max-width: 360px;
   text-align: center;
}

.share-icon {
   fill: #ffa726;
}
`, "",{"version":3,"sources":["webpack://./src/app/e-signature/contact/contact.component.css"],"names":[],"mappings":"AAAA;GACG,yBAAyB;AAC5B;;AAEA;GACG,mBAAmB;AACtB;;AAEA;GACG,WAAW;AACd;;AAEA;GACG,gBAAgB;AACnB;;AAEA;GACG,yBAAyB;GACzB,kBAAkB;GAClB,eAAe;GACf,cAAc;GACd,gBAAgB;GAChB,kBAAkB;GAClB,mBAAmB;AACtB;;AAEA;GACG,yBAAyB;GACzB,cAAc;GACd,qBAAqB;AACxB;;AAEA;GACG,yBAAyB;GACzB,qBAAqB;AACxB;;AAEA;GACG,eAAe;GACf,kBAAkB;AACrB;;AAEA;GACG,eAAe;AAClB;;AAEA;GACG,iBAAiB;AACpB;;AAEA;GACG,yBAAyB;GACzB,iBAAiB;AACpB;;AAEA;GACG,eAAe;GACf,kBAAkB;AACrB;;AAEA;GACG,YAAY;GACZ,6BAA6B;GAC7B,SAAS;GACT,aAAa;AAChB;;AAEA;GACG,UAAU;GACV,QAAQ;AACX;;AAEA;GACG,iBAAiB;GACjB,gBAAgB;GAChB,mBAAmB;AACtB;;AAEA;GACG,eAAe;GACf,WAAW;AACd;;AAEA;GACG,iBAAiB;AACpB;;AAEA;GACG,aAAa;AAChB;;AAEA;;GAEG;;;;gDAI6C;GAC7C,UAAU;AACb;;AAEA;GACG,UAAU;GACV,UAAU;AACb;;AAEA;GACG,iBAAiB;GACjB,kBAAkB;AACrB;;AAEA;GACG,cAAc;GACd,gBAAgB;GAChB,kBAAkB;AACrB;;AAEA;GACG,aAAa;AAChB","sourcesContent":["::ng-deep .no-header {\n   background-color: #ffffff;\n}\n\n.toolbar {\n   align-items: center;\n}\n\n.menu > li {\n   float: left;\n}\n\n.menu > li + li {\n   margin-left: 1em;\n}\n\n.menu > li > a {\n   border: 1px solid #bdc3c7;\n   border-radius: 2px;\n   cursor: pointer;\n   display: block;\n   padding: 5px 1em;\n   position: relative;\n   white-space: nowrap;\n}\n\n.menu > li > a:hover {\n   background-color: #f7f7f7;\n   color: #3d464d;\n   text-decoration: none;\n}\n\n.toolbar .dropdown.open > a {\n   background-color: #ebebeb;\n   border-color: #bdc3c7;\n}\n\n.menu > li > a > i {\n   font-size: 16px;\n   margin-right: 10px;\n}\n\n.menu button {\n   padding: 0 12px;\n}\n\n.menu button.mat-primary {\n   line-height: 30px;\n}\n\n.menu button:not(.mat-primary) {\n   border: 1px solid #bdc3c7;\n   line-height: 28px;\n}\n\n.menu button i {\n   font-size: 16px;\n   margin-right: 10px;\n}\n\n.separator {\n   border: none;\n   border-top: 1px solid #eaeaea;\n   height: 0;\n   margin: 5px 0;\n}\n\n.toolbar .dropdown-menu {\n   left: auto;\n   right: 0;\n}\n\n.breadcrumb1 {\n   line-height: 30px;\n   overflow: hidden;\n   white-space: nowrap;\n}\n\n.mat-form-field {\n   font-size: 14px;\n   width: 100%;\n}\n\n.mat-column-select {\n   overflow: visible;\n}\n\n.firstSampleAnimation {\n   padding: 20px;\n}\n\n.firstSampleAnimation.ng-hide-add,\n.firstSampleAnimation.ng-hide-remove {\n   /*-webkit-transition : 1s ease-in-out opacity;\n   -moz-transition    : 1s ease-in-out opacity;\n   -ms-transition     : 1s ease-in-out opacity;\n   -o-transition      : 1s ease-in-out opacity;\n   transition         : 1s ease-in-out opacity;*/\n   opacity: 1;\n}\n\n.firstSampleAnimation.ng-hide {\n   z-index: 1;\n   opacity: 0;\n}\n\n.search-box {\n   padding-left: 1em;\n   position: relative;\n}\n\n.rate-limit-reached {\n   color: #980000;\n   max-width: 360px;\n   text-align: center;\n}\n\n.share-icon {\n   fill: #ffa726;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
